import AppAPI from "../../app/api";
import { getCompanyIDfromUrl } from "../../app/utils/route";
import { DarkmodeStyle } from "../../styles/darkmode";
import CompanyContacts from "./components/contacts";
import ViewTags from "./components/tags";
import { CompanyDescription, CompanyHeaderContainer, CompanyLogo, CompanyStand, CompanyTitle, ViewBodyContainer, ViewHeaderContainer, ViewPageContainer } from "./styles";

export default function ViewPage() {
  const companyId = process.env.NODE_ENV === "production" ? getCompanyIDfromUrl() : 7
  const { data: company } = AppAPI.useGetCompanyInfoQuery(companyId!)

  if (!company) {
    return <></>
  }

  return (
    <ViewPageContainer>
      <DarkmodeStyle />
      <ViewHeaderContainer>
        <CompanyHeaderContainer>
          <CompanyLogo src={company.urlLogoFromWeb} />
          <CompanyTitle children={company.name} />
        </CompanyHeaderContainer>

        <ViewTags activities={company.activities} />

        <CompanyStand children={company.stend} />
      </ViewHeaderContainer>

      <ViewBodyContainer>
        <CompanyDescription dangerouslySetInnerHTML={{ __html: company.specification }} />
        <CompanyContacts company={company} />
      </ViewBodyContainer>
    </ViewPageContainer>
  )
}
